// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"09632663","498":"53e9af35","703":"ddc4f9f4"}[chunkId] + ".chunk.js";
};